import * as Actions from '../../Store/Actions/TabelaHorasActions';

const initialState = {
    info: null,
    error: null,
    warning: null,
    jornada: null,
};

const TabelaHorasReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.TABELAHORAS_GET_JORNADA:
            {
                return {
                    ...state,
                    jornada: action.payload.jornada
                }
            }
        case Actions.TABELAHORAS_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                }
            }
        case Actions.TABELAHORAS_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                }
            }
        case Actions.TABELAHORAS_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
};

const reducer = TabelaHorasReducer;
export default reducer;
